export class ConsumerCompetitionGoalStats {

  public goalId: string;
  public endValue = 0;
  public numReached = 0;

  static generateModel(json: any): ConsumerCompetitionGoalStats {

    const goal = new ConsumerCompetitionGoalStats();
    goal.goalId = json.goalId;
    goal.endValue = json.endValue || 0;
    goal.numReached = json.numReached || 0;
    return goal;

  }

}

/**
 * The stats of a consumer competition, computed by the backend on every request.
 */
export class ConsumerCompetitionStats {

  public competitionId: string;
  public numStudents = 0;
  public numAnswers = 0;
  public numCorrect = 0;
  public goals: ConsumerCompetitionGoalStats[] = [];
  public updatedAt: Date;

  static generateModel(json: any): ConsumerCompetitionStats {

    const stats = new ConsumerCompetitionStats();
    stats.competitionId = json.competitionId;
    stats.numStudents = json.numStudents || 0;
    stats.numAnswers = json.numAnswers || 0;
    stats.numCorrect = json.numCorrect || 0;

    if (json.goals) {
      for (const goal of json.goals) {
        stats.goals.push(ConsumerCompetitionGoalStats.generateModel(goal));
      }
    }

    if (json.updatedAt) {
      stats.updatedAt = new Date(json.updatedAt);
    }

    return stats;

  }

  /**
   * The share of children that reached the goal, 0 to 100. There is no percentage in the response
   * and numStudents can be 0.
   */
  getReachedPercentage(goal: ConsumerCompetitionGoalStats): number {

    if (this.numStudents <= 0) {
      return 0;
    }

    return (goal.numReached / this.numStudents) * 100;

  }

}
